import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';

import {HttpClientModule} from '@angular/common/http';
import {HttpCancelService} from "./services/http-cancel.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {ManageHttpInterceptor } from './interceptors/managehttp.interceptor';

import {FormsModule} from '@angular/forms';
import {registerLocaleData} from "@angular/common";
import localeEn from '@angular/common/locales/en-AU';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as exporting from 'highcharts/modules/exporting.src';

import {ScienceApiService} from './services/science-api.service';
import {SoilService} from "./services/soil.service";
import {ChartService} from "./services/chart.service";

import {APP_BASE_HREF} from '@angular/common';

import {StartDateBeforeEndDateValidatorDirective} from './directives/date-validator.directive';
import {RangeValidatorDirective} from "./directives/range.directive";

import {NgbDateAuParserFormatterComponent} from "./ngb-date-au-parser-formatter/ngb-date-au-parser-formatter.component";

registerLocaleData(localeEn, 'en/AU');

declare var Drupal: any;
let basePath = '/soil-water/'; //((typeof Drupal !== 'undefined')) ? '/' + Drupal.settings.pathAlias : '/';

@NgModule({
    declarations: [
        AppComponent,
        StartDateBeforeEndDateValidatorDirective,
        RangeValidatorDirective
    ],
    imports: [
        HttpClientModule,
        ChartModule,
        NgbModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        RouterModule
    ],
    providers: [
        ScienceApiService,
        SoilService,
        HttpCancelService,
        ChartService,
        { provide: HIGHCHARTS_MODULES, useFactory: () => [exporting] },
        { provide: APP_BASE_HREF, useValue: basePath },
        { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true },
        {provide: NgbDateParserFormatter, useClass: NgbDateAuParserFormatterComponent}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
